<template>
    <div>
      <div class="search_container">
        <div style="padding-top: 30px;">
          <span style="padding-right: 20px">搜索</span>
          <el-input v-model="searchValue" placeholder="请输入搜索内容" style="width: 200px; padding-right: 20px"/>
          <el-button type="primary" style="padding-left: 20px" @click="searchBtnClick">搜索</el-button>
        </div>
      </div>
      <el-table
        :data="dataList"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        style="width: 100%;margin-top: 20px">
        <el-table-column
          label="直播ID"
          prop="Id">
        </el-table-column>
        <el-table-column
          label="直播名称" width="150"
          prop="Title">
        </el-table-column>
        <el-table-column
          label="直播时间" width="200">
          <template slot-scope="props">
            <div style="text-align: center">
              <p> {{ formatLiveTime(props.row.BeginTime, props.row.EndTime) }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="selectMasterClass(scope.$index, scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'DoubleTeaMasterListComponent',
    data () {
      return {
        dataList: [],
        currentPage: 1,
        pageCount: 10,
        totalCount: 0,
        searchValue: ''
      }
    },
    created () {
      this.getMasterClassList()
    },
    methods: {
      getMasterClassList () {
        if (this.searchValue === '') {
          let requestData = {courseid: this.$route.query.courseId, page: this.currentPage, count: this.pageCount}
          this.$api.courseManager.getMasetLiveByCourse(requestData).then((res) => {
            if (res.code === 0) {
              this.dataList = res.data
              this.totalCount = res.count
            }
          })
        } else {
          let requestData = {courseid: this.$route.query.courseId, page: this.currentPage, count: this.pageCount, key: this.searchValue}
          this.$api.courseManager.searchMasetLiveByCourse(requestData).then((res) => {
            if (res.code === 0) {
              this.dataList = res.data
              this.totalCount = res.count
            }
          })
        }

      },
      selectMasterClass (index, row) {
        this.$emit('selectMasterClass',row)
      },
      searchBtnClick () {
        this.getMasterClassList()
      },
      handleSizeChange (val) {
        this.pageCount = val
        this.currentPage = 1
        this.getMasterClassList()
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this.getMasterClassList()
      },
      formatLiveTime (beginTime, endTime) {
        let timeStr = this.formatDate('YYYY-mm-dd HH:MM', beginTime) + ' - ' + this.formatDate('HH:MM', endTime)
        return timeStr
      },
      formatDate (fmt, dateStr) {
        let date = new Date(dateStr)
        let ret
        let opt = {
          'Y+': date.getFullYear().toString(),
          'm+': (date.getMonth() + 1).toString(),
          'd+': date.getDate().toString(),
          'H+': date.getHours().toString(),
          'M+': date.getMinutes().toString(),
          'S+': date.getSeconds().toString()
        }
        for (let k in opt) {
          ret = new RegExp('(' + k + ')').exec(fmt)
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
          };
        };
        return fmt
      }
    }
  }
</script>

<style scoped>
  .Pagination{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/course/DoubleTeaMasterListComponent.vue